export const FormatStringToNumber = (value: string): number => {
  const formattedValue = value.replace(",", ".");

  const numberValue = parseFloat(formattedValue);

  return  numberValue;
};
